import { TermsOfSale, orUndefined, schTermsOfSale } from '@aloft/toolkit-shared';

import { extractAdjustmentDescription } from './extractAdjustmentDescription.ts';

export function extractTermsOfSale(sale: Element): TermsOfSale | undefined {
  try {
    return orUndefined(schTermsOfSale.parse)(
      extractAdjustmentDescription(sale, 'SalesConcessions'),
    );
  } catch (e: unknown) {
    console.warn('Failed to parse terms of sale', e);
    return undefined;
  }
}
